/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 18:43 23.04.2023
 * @ Description: Page qui affiche la sentence
 */


import "./index.css";
import GamePageManager from "../../utils/GamePageManager";
import GameAdmin from "../../GameClass/gameAdmin";
import StatsShower from "../../compenent/statsShower/statsShower";
import MyButton from "../../compenent/button/MyButton";
import React, { useRef, useState,useEffect } from 'react';
import Sentence from "../../GameClass/sentence";

export default function GameSentenceShower() {

    const WORD_BUTTON_FONT_SIZE=25;

    const sentence=useRef(null);
    const timeOnLevel=useRef(0);

    // hook
    const [toggleAnswer,setToggleAnswer] = useState(false);
    const [answers,setAnswer]=useState(null);
    const [showAddPoint,setShowAddPoint]=useState(null);
    const [correctionInfo,setCorrectionInfo]=useState([0,0,0]);
    const [sentenceShower,setSentenceShower]=useState(null);
    const [timer,setTimer]=useState(0);
    const [score,setScore]=useState(10);


    /**
     * On show Answer
     */
    function showAnswers(){
        setToggleAnswer(true);
        setAnswer(sentence.current.generateWordButtonsAnswer(WORD_BUTTON_FONT_SIZE));


        GameAdmin.instance.timer=timer+((sentence.current.actualAnswerWord.length==0)?10:0);


        // ajout des point
        let addpoint=sentence.current.correct();
        addpoint+=(sentence.current.correctionInfo[2]==0)?GameAdmin.instance.perfectBonnus:0;
        setShowAddPoint(addpoint);
        setScore(GameAdmin.instance.addPoint(addpoint));

        // set corection info
        setCorrectionInfo(sentence.current.correctionInfo);
    }


    /**
     * Fonction qui appler a chaque seconde du timer
     */
    function timerFunction(){
        if(toggleAnswer)return;
        timeOnLevel.current+=1;
        setTimer(timer+1);
        if((timer+1)>GameAdmin.instance.maxTime){
            // finish screen
            GamePageManager.changePage("GameFinishScreen");
        }
    }


    /**
     * Format time en "hh:mm:ss"
     * @param {int} time time en sconde
     * @returns {string} formated time
     */
    function formatTime(time){
        return new Date((time) * 1000).toISOString().slice(14, 19);
    }


    // setup les variable
    useEffect(()=>{
        if(GameAdmin.instance==undefined){
            GamePageManager.changePage("GameLoading");
            return;
        }
        setTimer(GameAdmin.instance.timer);
        setScore(GameAdmin.instance.score);
        sentence.current=GameAdmin.instance.getActualSentence();
        setSentenceShower(sentence.current.generateWordButtons(WORD_BUTTON_FONT_SIZE));
    },[]);
    

    // gère le timer de manière pas ouf, mais bon ça marche donc let's go :) (faudras que je regarde comment le faire en plus propre)
    useEffect(()=>{
        if(toggleAnswer)return;
        setTimeout(()=>{timerFunction();},1000);
    },[timer]);

    return (
        <div className="GamePage GameSentenceShower">
            <StatsShower time={formatTime(Math.max(0,GameAdmin.instance.maxTime-timer))} score={score.toString()} level={"phrases "+(GameAdmin.instance.level+1)}/>
            <div className="sentence">
                <div className={(!toggleAnswer?"playerInputContainer":"hide")}>{sentenceShower}</div>
                <div className={(toggleAnswer?"answer":"hide")}>{answers}</div>
                <div className={(toggleAnswer)?"stats":"hide"}>
                    <div className="correctionInfo">
                        <p className="correct">correct : {correctionInfo[0]}</p>
                        <p className="false">false : {correctionInfo[1]}</p>
                        <p className="miss">miss : {correctionInfo[2]}</p>
                    </div>
                    <div className="addPoint">
                        {correctionInfo[2]==0?<p className="correct prefect"> PREFECT : {GameAdmin.instance.perfectBonnus}</p>:null}
                        <p>result : {showAddPoint}</p>
                    </div>
                </div>
            </div>
            <div className="end">
                <MyButton title={(toggleAnswer?"Next":"Check")} onClick={()=>{
                    if(!toggleAnswer){
                        showAnswers();
                    }
                    else{
                        GameAdmin.instance.nextLevel();
                    }
                }} fontSize={40}/>
            </div>
        </div>
    );
}
